import { create } from 'zustand';
import { organizationsService } from '@/services/organizations';
import type { OrganizationUsage } from '@/types';

interface UsageState {
  usage: OrganizationUsage | null;
  isLoading: boolean;
  error: string | null;

  fetchUsage: (orgId: string) => Promise<void>;
  clearUsage: () => void;
}

/**
 * Billable usage for the current period. Kept in its own store because usage is
 * derived from ClickHouse on read rather than carried on the organization, and
 * is shown on the dashboard, settings and billing pages alike.
 */
export const useUsageStore = create<UsageState>()((set) => ({
  usage: null,
  isLoading: false,
  error: null,

  fetchUsage: async (orgId: string) => {
    set({ isLoading: true, error: null });
    try {
      const usage = await organizationsService.getUsage(orgId);
      set({ usage, isLoading: false });
    } catch {
      // ClickHouse may be briefly unavailable; keep the last known value rather
      // than flashing a zero, which would read as "no usage".
      set({ error: 'Failed to load usage', isLoading: false });
    }
  },

  clearUsage: () => set({ usage: null, error: null }),
}));

export default useUsageStore;
